export function headSectionService(http) {
    const serviceName = "HeadSection";

    return {
        getCartable: (userId,roleMembers,pageNumber,pageSize,sortBy,cartableTypeId,filters) => {
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))


            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });

            var data={
                    user:{id:userId},
                    roleMembers,
                    cartableTypeId,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.length>0?newSortBy:[{member:'KeyId',sortDirection:'Descending'}],
                        filter:newfilter.length>0 
                        ?{
                            logic:"And",
                            filters:newfilter
                        }
                        :null
                    }
            };
            return http.post(serviceName + "/GetCartable",data)
            
        },
        getCoordinatorSuggestion: (keyId) => {
            return http.get(serviceName + `/GetCoordinatorSuggestion?keyId=${keyId}`);
        },
        assignTasks:(currentUser,formData,shortMessages)=>{
            
            const data = {
                currentUser,
                tasks:formData,
                shortMessages
            };
            return http.post(serviceName + "/AssignTasks",data);//.then(result=>result.data );
        },
        newAssignByHeadSection:(activityTypeId,assignId,uniqueId,currentUserId,headSectionActionTypeId,responsible,workflowCategoryType)=>{
            const data={
                activityTypeId,
                assignId,
                uniqueId,
                headSectionActionTypeId,
                user:{
                    id:currentUserId
                },
                responsible,
                workflowCategoryType
            };
            return http.post(serviceName+"/NewAssign",data);
        },
        forwardTaskCycleToCoordinator:(keyId,assignId,keyStatusTypeId,userId,uniqueId,holdReasonId,workflowCategoryType)=>{
            const data={
                        keyId,
                        keyStatusTypeId,
                        assignId,
                        user:{
                            id:userId
                        },
                        uniqueId,
                        holdReasonId,
                        workflowCategoryType
            }
            return http.post(serviceName + "/ForwardTaskCycleToCoordinator",data)
        },
        finalResponsibleFlowCycle:(keyId,assignId,keyStatusTypeId,userId,uniqueId,workflowCategoryType)=>{
            const data={
                        keyId,
                        keyStatusTypeId,
                        assignId,
                        user:{
                            id:userId
                        },
                        uniqueId,
                        workflowCategoryType
            }
            return http.post(serviceName + "/FinalResponibleFlowCycle",data)
        },
        final:(keyId,userId,uniqueId,workflowCategoryType)=>{
            const data={
                        keyId,
                        user:{
                            id:userId
                        },
                        uniqueId,
                        workflowCategoryType
            }
            return http.post(serviceName + "/Final",data)
        },
        updatePeriority:(keyId,priorityTypeId)=>{
            const data={
                keyId,
                priorityTypeId
                }
                return http.post(serviceName + "/UpdatePeriority",data)
        },
        getAvailableUsersOnProjects:(projectId,disciplineId)=>{
                return http.get(`${serviceName}/GetAvailableUsersOnProjects?projectId=${projectId}&disciplineId=${disciplineId}`);
        },
        updateAvailableUsersOnProjects:(availableUsers)=>{
            const data={
                availableUsers
            }
            return http.post(`${serviceName}/UpdateAvailableUsersOnProjects`,data);
        }

    }
}